import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Swiper, SwiperSlide } from "swiper/react";
  import LoadingScreen from "../../components/LoadingScreen";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import axiosInstance, { weburl } from '../../../axiosInstance';
import getDecryptData from '../../../helper/getDecryptData';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import Select from 'react-select'; // Import react-select

const ViewHospital = () => {

  const  { sendMessage } = useBlogContext();


const navigate = useNavigate();

      const decryptdatajson = getDecryptData();
      const userId = decryptdatajson?._id;

    const { id } = useParams();

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

  const [formData, setFormData] = useState({
    userId: userId || "",
    vendorId: id,
    rating: "",
    comment: "",
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

    const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

  

    setFilterInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

    const togglePopup = () => {
    setIsOpen(!isOpen);
  };

    const [isOpen, setIsOpen] = useState(false);

      const [Page, setPage] = useState({});
      const [latestAd, setLatestAd] = useState(null);
    
  const [loading, setloading] = useState(true);
    const [SubmitRLoading, setSubmitRLoading] = useState(true);


        const [AllCategory, setAllCategory] = useState([]);
  const [AllRating, setAllRating] = useState([]);


        const [isOpenReview, setIsOpenReview] = useState(false);
         


  const getUser = async () => {

 
    setloading(true);

    try {
      const { data } = await axiosInstance.get(`/get-vendor/${id}`);
      setPage(data.Mpage);
         setLatestAd(data.latestAd || null);

          const {success} = data;
        if(!success){
       navigate('/home')
        }
    } catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  };


    const [data2, setData2] = useState([]);

     const initialFilterData = {
  location: "",
  placeId: "",
  Experience: null,
  };

    const [filterInputs, setFilterInputs] = useState(initialFilterData);
  
  
      const getcatgeory = async () => {
   
     try {
        const { data } = await axiosInstance.get(`/all-hospital-doctor?headId=${id}&department=${filterInputs.department ?? ''}`);
        setAllCategory(data.users);
          setData2(data.allSubDepartments??[]);

      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    

      const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/view-vendor-rating/${id}`);
      const productRatings = data.productRatings; // Extract the array from the response
      
      if (productRatings) {
        setAllRating(productRatings); // Set state with the actual reviews
      }
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };



        const AddRating = async () => {
          setSubmitRLoading(false);
      
          if (!userId ) {
            toast.error("Please Login First");
            setSubmitRLoading(true);
      
            return;
          } else {
            if (formData.rating !== "" || formData.comment !== "") {
              try {
                await axiosInstance.post("/add-vendor-rating", formData);
                toggleReviewPopup();
                toast.success("Rating Added successfully!");
                getRating();
              } catch (error) {
                console.error("Error on rating added:", error);
                toast.error(error.response.data.message);
                // setRatings([]);
              } finally {
                setSubmitRLoading(true);
              }
            } else {
              toast.error("Please Fill All Fields");
              setSubmitRLoading(true);
            }
          }
        };
      

          const toggleReviewPopup = () => {
            if (userId) {
              setIsOpenReview(!isOpenReview);
            } else {
              toast.error("Please Login First", );
            }
          };
        


  useEffect(() => {
     getUser();
    getRating();
    window.scrollTo(0, 0);
  }, [id]);

    useEffect(() => {
    getcatgeory();
 
  }, [id, filterInputs.department]);
  
const ReviewCard = ({ rating, comment, username, createdAt }) => {
  // Convert the date to a readable format
  const formattedDate = new Date(createdAt).toLocaleDateString();

  // Generate stars based on the rating
  const stars = "★".repeat(rating) + "☆".repeat(5 - rating);

  return (
    <div className="th-review">
      <div className="d-flex align-items-center justify-content-between">
        <div className="fw-semibold">{username}</div>
        <div className="text-secondary small">{formattedDate}</div>
      </div>
      <div className="th-stars">{stars}</div>
      <p className="mb-2">{comment}</p>
      {/* <div className="th-ctrl">
        <button className="btn btn-sm btn-outline-secondary">Helpful</button>
        <button className="btn btn-sm btn-outline-secondary">Comment</button>
        <button className="btn btn-sm btn-outline-secondary">Share</button>
      </div> */}
    </div>
  );
};


  // Calculate the average rating
  const calculateAverageRating = (ratings) => {
    if (ratings.length === 0) return 0;
    const totalRating = ratings.reduce((sum, review) => sum + review.rating, 0);
    return (totalRating / ratings.length).toFixed(1); // Rounded to one decimal point
  };

  const averageRating = calculateAverageRating(AllRating);

  const stars = "★".repeat(Math.floor(averageRating)) + "☆".repeat(5 - Math.floor(averageRating));


    const [enquireData, setEnquireData] = useState([]);
    const [EnquireStatus, setEnquireStatus] = useState(false);
        const [EnquireShow, setEnquireShow] = useState(false);

          const [DataShow, setDataShow] = useState(true);

    
  const enquireToggle = (service) => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
         setEnquireData((prevData) => ({
      ...prevData,
      service: service,
    }));
    }
  };

  
  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10); // Limit to 10 digits
      }
    }

    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };


    const handleSendEnquire = async () => {
      console.log('enquireData',enquireData)
          setEnquireStatus(true);

      const fields = [
        { name: "fullname", message: "Please enter Full Name" },
        { name: "phone", message: "Please enter phone number" },
        { name: "email", message: "Please enter email" },
      
      ];
  
      for (const field of fields) {
        if (!enquireData[field.name]) {
          toast.error(field.message);
          setEnquireStatus(false);
          return;
        }
      }
  
     const finaldata =  {
      ...enquireData,
      senderId: id,
      userId: decryptdatajson?._id ?? '',
     }

           
      try {
        await toast.promise(axiosInstance.post(`/send-enquire`, finaldata), {
          loading: "Enquire Submiting...", // Loading message
          success: "Enquire Submited Successfully!", // Success message
          error: "Failed to Submit Enquire.", // Error message
        });
        enquireToggle();
        setEnquireData((prevData) => ({
          ...prevData,
          fullname: "",
          email: "",
          phone: "",
          service: "",
          QTY: "",
        })); // Clear form fields
        
        setDataShow(true);
        enquireToggle();

      } catch (error) {
        console.error("Failed to send email:", error);
        // toast.error('Failed to send email');
      } finally {
        setEnquireStatus(false);
      }
    };

      useEffect(() => {
   
    if(loading && decryptdatajson){
    setEnquireData((prevData) => ({
      ...prevData,
      fullname: decryptdatajson.username ?? '',
      phone: decryptdatajson.phone ?? '',
      email: decryptdatajson.email ?? '',
    }));

    }
  }, [decryptdatajson]);

 
  const stories = [
  {
    id: 1,
    title: "Fibroid Removal | Patient Success Story",
    doctor: "Dr. Suman Lal",
    hospital: "Max Hospital, Gurgaon",
    date: "Dec 10, 2024",
    image: "/assets/img/landscape.webp",
  },
  {
    id: 2,
    title: "A Safe Pregnancy Despite Large Fibroids",
    doctor: "Dr. Ritu Sethi",
    hospital: "Max Hospital, Gurgaon",
    date: "Nov 23, 2024",
    image: "/assets/img/landscape.webp",
  },
  {
    id: 3,
    title: "Successful Recovery from Lifelong Allergic Rhinitis",
    doctor: "Dr. Ravinder Gera",
    hospital: "Max Hospital, Gurgaon",
    date: "Oct 7, 2024",
    image: "/assets/img/landscape.webp",
  },
  {
    id: 4,
    title: "Cured with Laparoscopy Surgery",
    doctor: "Dr. Suman Lal",
    hospital: "Max Hospital, Gurgaon",
    date: "Aug 31, 2024",
    image: "/assets/img/landscape.webp",
  },
  {
    id: 5,
    title: "Surgery for Brain Tumour",
    doctor: "Dr. Arun Saroha",
    hospital: "Max Hospital, Gurgaon",
    date: "Feb 26, 2024",
    image: "/assets/img/landscape.webp",
  },
  {
    id: 6,
    title: "TLIF Surgery for L-4,5 Spondylolysis",
    doctor: "Dr. Arun Saroha",
    hospital: "Max Hospital, Gurgaon",
    date: "Jan 25, 2024",
    image: "/assets/img/landscape.webp",
  }
];

  const faqItems =
    Array.isArray(Page?.faq) && Page.faq.length > 0
      ? Page.faq
      : [];

        const statsItems =
    Array.isArray(Page?.stats) && Page.stats.length > 0
      ? Page.stats
      : [];

  const [selectedStory, setSelectedStory] = useState(stories[0]); // show first story initially

  return (
    <>
      <Header title={Page?.username ?? 'none'} />


 

     <main className="page">
 {loading ? 
<>
{/* HERO */}
<section className="page-hero py-4 py-lg-5">
  <div className="container">

    {/* Breadcrumb */}
    <div className="small text-muted mb-3 d-flex gap-2">
      <div className="skeleton skeleton-text" style={{width: "20%"}}></div>
      <div className="skeleton skeleton-text" style={{width: "10%"}}></div>
            <div className="skeleton skeleton-text" style={{width: "20%"}}></div>
    </div>

    <div className="row g-4 align-items-start">

      {/* LEFT: Hospital identity */}
      <div className="col-lg-4">
        <div className="glass p-4">
          <div className="d-flex align-items-start justify-content-between gap-3">
            <div className="d-flex align-items-center gap-3">
              <div className="skeleton rounded-circle" style={{width: 56, height: 56}}></div>
              <div>
                <div className="skeleton skeleton-text" style={{width: "80%", height: "20px"}}></div>
                <div className="skeleton skeleton-text" style={{width: "50%", height: "15px"}}></div>
              </div>
            </div>

            <div className="skeleton rounded-pill" style={{width: "100px", height: "30px"}}></div>
          </div>

          {/* Trust row */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "100px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "100px", height: "20px"}}></div>
          </div>

          <hr className="my-4" />

          {/* Key info */}
          <div className="d-flex gap-3 mb-3">
            <div className="skeleton rounded-circle" style={{width: 38, height: 38}}></div>
            <div>
              <div className="skeleton skeleton-text" style={{width: "60%", height: "20px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "50%", height: "15px"}}></div>
            </div>
          </div>

          {/* Highlights */}
          <div className="d-flex flex-wrap gap-2 mt-3">
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
          </div>

          {/* CTAs */}
          <div className="d-flex gap-2 mt-4 flex-wrap">
            <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
            <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
          </div>

        </div>
      </div>

      {/* CENTER: Gallery + Map */}
      <div className="col-lg-5">
        <div className="thumb mb-3">
          <div className="skeleton skeleton-img" style={{width: "100%", height: "200px"}}></div>
        </div>

        <div className="row g-3">
          <div className="col-4">
            <div className="thumb">
              <div className="skeleton skeleton-img" style={{width: "100%", height: "200px", aspectRatio: '1/1'}}></div>
            </div>
          </div>
          <div className="col-4">
            <div className="thumb">
              <div className="skeleton skeleton-img" style={{width: "100%",  height: "200px",aspectRatio: '1/1'}}></div>
            </div>
          </div>
          <div className="col-4">
            <div className="thumb d-flex align-items-center justify-content-center position-relative" style={{minHeight: 96}}>
              <div className="skeleton skeleton-img" style={{width: "100%", height: "100%"}}></div>
            </div>
          </div>
        </div>

        <div className="thumb mt-3">
          <div className="skeleton skeleton-img" style={{width: "100%", height: "300px"}}></div>
        </div>
      </div>

      {/* RIGHT: Sticky booking */}
      <div className="col-lg-3">
        <div className="sticky-side">
          <div className="glass p-4">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="skeleton skeleton-text" style={{width: "60%", height: "20px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "30%", height: "20px"}}></div>
            </div>

            <div className="text-muted small mb-3">
              <div className="skeleton skeleton-text" style={{width: "80%", height: "15px"}}></div>
            </div>

            <div className="row g-2">
              <div className="col-12">
                <div className="skeleton skeleton-input" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-input" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-select" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-select" style={{width: "100%", height: "40px"}}></div>
              </div>
              <div className="col-12">
                <div className="skeleton skeleton-btn" style={{width: "100%", height: "40px"}}></div>
              </div>
            </div>

            <div className="d-flex gap-2 mt-3 flex-wrap">
              <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
              <div className="skeleton skeleton-text" style={{width: "80px", height: "20px"}}></div>
            </div>

            <div className="small text-muted mt-3">
              <div className="skeleton skeleton-text" style={{width: "100%", height: "15px"}}></div>
            </div>

          </div>
        </div>
      </div>

    </div>

    {/* Tabs */}
    <div className="mt-4">
      <ul className="nav nav-pills gap-2 navtabs flex-wrap">
        <div className="skeleton skeleton-text" style={{width: "10%", height: "30px"}}></div>
          <div className="skeleton skeleton-text" style={{width: "10%", height: "30px"}}></div>
                    <div className="skeleton skeleton-text" style={{width: "10%", height: "30px"}}></div>
                              <div className="skeleton skeleton-text" style={{width: "10%", height: "30px"}}></div>
      </ul>
    </div>

  </div>
</section>

</>
: 
<>
 
   {isOpen && (
                <>
                  <div class="propop">
                    <i onClick={togglePopup} class="ri-close-line" type="button" ></i>

                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#335599",
                        "--swiper-pagination-color": "#335599",
                        "padding-bottom": "40px",
                      }}
                      spaceBetween={10}
                      navigation={true}
                      pagination={true}
                      modules={[FreeMode, Navigation, Pagination]}
                      className="mySwiper2  "
                    >

          {Array.from({ length: 8 }, (_, i) => Page?.[`Doc${i + 3}`]) // Doc3 → Doc10
  .filter(Boolean) // remove null, undefined, empty
  .map((imgSrc, index) => (
    <SwiperSlide key={index} className='w-100'>
      <div className='d-block'>
     <img
        src={weburl+imgSrc}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/assets/img/placeholder.png';
        }}
        className="w-100 object-fit-contain"
        alt={`Image ${index + 1}`}
        style={{ aspectRatio: '1 / 1' }}
      />
      </div>
 
    </SwiperSlide>
  ))}


  
                    </Swiper>
                  </div>
                </>
              )}

 {/* HERO */}
  <section className="page-hero py-4 py-lg-5">
    <div className="container">

      {/* Breadcrumb */}
      <div className="small text-muted mb-3">
        Home <span className="mx-1"   >›</span> <span  onClick={() => navigate('/all-clinic')} type="button"> Clinic </span>  <span className="mx-1">›</span>
        <span className="fw-semibold text-dark"> {Page?.username ?? 'anonymous'} </span>
      </div>

      <div className="row g-4 align-items-start">

        {/* LEFT: Hospital identity */}
        <div className="col-lg-4">
          <div className="glass p-4">

            <div className="d-flex align-items-start justify-content-between gap-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{aspectRatio: "1/1",width:56,height:56, background:"rgba(13,110,253,.12)", color:"var(--navy)", fontWeight:900}}
                >
                  <img
                                              src={
                                                Page &&
                                                  typeof Page.profile === "string" &&
                                                  Page.profile !== ""
                                                  ? weburl + Page.profile.replace("public", "")
                                                  : "/assets/img/placeholder.png"
                                              }
                                              onError={(e) =>
                                                (e.target.src = "/assets/img/placeholder.png")
                                              }
                                              width="100%"
                                              className="rounded w-100 mb-0 rounded-circle"
                                              style={{ aspectRatio: "1/1", objectFit: "cover" }}
                                            />
                </div>

                <div>
                  <div className="fw-bold fs-4" style={{color:"var(--navy)"}}>
                {Page?.username ?? 'anonymous'}
                  </div>
                  <div className="text-muted small">
                    Dental • Multi-speciality • ISO Certified
                  </div>
                </div>
              </div>

              <span className="badge bg-success-subtle text-success rounded-pill px-3 py-2">
                Open Now
              </span>
            </div>

            {/* Trust row */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              {/* <span className="pill">
                <span className="fw-bold"> <img width={20} src="/assets/img/google-logo.svg"/> </span>
                <span className="fw-bold">4.9</span>
                <span style={{color:"#F4B400"}}>★★★★★</span>
                <span className="text-muted">(250+)</span>
              </span> */}
              <span className="pill">✅ Verified Listing</span>
             </div>

            <hr className="my-4" />

            {/* Key info */}
            <div className="d-flex gap-3 mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center"
                   style={{width:38,height:38, background:"rgba(255,193,7,.18)"}}>
                📍
              </div>
              <div>
                <div className="fw-semibold">{Page?.statename ?? 'NA'}</div>
                <div className="text-muted small">{Page?.location ?? 'NA'}</div>
                <a href="#" className="text-decoration-none fw-semibold">Get Directions →</a>
              </div>
            </div>

            {/* <div className="d-flex gap-3 mb-3">
              <div className="rounded-circle d-flex align-items-center justify-content-center"
                   style={{width:38,height:38, background:"rgba(13,110,253,.12)"}}>
                ⏰
              </div>
              <div>
                <div className="fw-semibold">10:00 AM – 08:00 PM</div>
                <div className="text-muted small">Closed on Monday</div>
              </div>
            </div> */}

            {/* Highlights */}
            <div className="d-flex flex-wrap gap-2 mt-3">
              
          {Page.stats && Page.stats.map((certification, index) => (
            <span className="pill" key={index}>{certification.value} {certification.label}</span>
        ))}
 
            </div>

            {/* CTAs */}
            <div className="d-flex gap-2 mt-4 flex-wrap">
              <a href="tel:9667353232" className="btn btn-outline-primary cta-btn flex-grow-1">
                📞 Call
              </a>
              <button className="btn btn-primary cta-btn flex-grow-1">
                📅 Book Appointment
              </button>
            </div>

          </div>
        </div>

        {/* CENTER: Gallery + Map */}
        <div className="col-lg-5 ">





          <div className="thumb mb-3" type="button" onClick={togglePopup}  >
            <img  className="img-fluid  object-fit-cover object-center w-100 h-100" alt="hospital"  
              src={
                                                Page &&
                                                  typeof Page.profile === "string" &&
                                                  Page.profile !== ""
                                                  ? weburl + Page.profile
                                                  : "/assets/img/placeholder.png"
                                              }
                                              onError={(e) =>
                                                (e.target.src = "/assets/img/placeholder.png")
                                              }
                                               />
          </div>

          <div className="row g-3">
            <div className="col-4">
              <div className="thumb w-100 h-auto"  type="button" onClick={togglePopup}  style={{aspectRatio:'1/1'}} >
                <img className="img-fluid  object-fit-cover object-center w-100 h-100" alt="gallery" 
                src={
                                                Page &&
                                                  typeof Page.Doc4 === "string" &&
                                                  Page.Doc4 !== ""
                                                  ? weburl + Page.Doc4
                                                  : "/assets/img/placeholder.png"
                                              }
                                              onError={(e) =>
                                                (e.target.src = "/assets/img/placeholder.png")
                                              }
                                                style={{aspectRatio:'1/1'}}/>
              </div>
            </div>
            <div className="col-4">
              <div className="thumb w-100 h-auto"  type="button" onClick={togglePopup}   style={{aspectRatio:'1/1'}} >
                <img className="img-fluid w-100 h-100 object-fit-cover object-center" alt="gallery" 
                      src={ 
                          Page &&
                                                  typeof Page.Doc5 === "string" &&
                                                  Page.Doc5 !== ""
                                                  ? weburl + Page.Doc5
                                                  : "/assets/img/placeholder.png"
                                              }
                                              onError={(e) =>
                                                (e.target.src = "/assets/img/placeholder.png")
                                              }
                                              />
              </div>
            </div>
            <div className="col-4">
              <div className="thumb d-flex align-items-center justify-content-center position-relative w-100 h-auto" style={{minHeight:96,aspectRatio:'1/1'}}  type="button" onClick={togglePopup}  >
                  <img className="img-fluid w-100 h-100  position-absolute object-fit-cover object-center object-center" alt="gallery" 
                   src={ 
                          Page &&
                                                  typeof Page.Doc6 === "string" &&
                                                  Page.Doc6 !== ""
                                                  ? weburl + Page.Doc6
                                                  : "/assets/img/placeholder.png"
                                              }
                                              onError={(e) =>
                                                (e.target.src = "/assets/img/placeholder.png")
                                              }
                                                     style={{aspectRatio:'1/1'}}/>
                 <button className="btn btn-light border rounded-pill z-1 btn-sm">View All <i className="ri-arrow-right-line" /> </button>
              </div>
            </div>
          </div>

          <div className="thumb mt-3"  type="button" onClick={togglePopup}  >

            <iframe
  src={`https://www.google.com/maps?q=${encodeURIComponent(Page.location)}&hl=en&z=14&output=embed`}
  className="w-100 rounded-3"
  style={{ border: 0 }}
   width={600}
  height={500}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
 
           </div>
        </div>
          


        {/* RIGHT: Sticky booking */}
        <div className="col-lg-3">
          <div className="sticky-side">
            <div className="glass p-4">

              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="fw-bold" style={{color:"var(--navy)"}}>Book a Slot</div>
                {/* <span className="badge bg-warning-subtle text-warning rounded-pill">Upto 25% OFF</span> */}
              </div>

              <div className="text-muted small mb-3">
                Get priority confirmation within minutes.
              </div>

              <div className="row g-2">
                <div className="col-12">
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                    placeholder='Full Name'
                  />
                </div>
                <div className="col-12">
                 <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={enquireData.phone}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                    placeholder='Phone Number'
                  />
                </div>
                <div className="col-12">
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                     placeholder='Email'
                  />
                </div>
                <div className="col-12">
                  <select className="form-select">
                    <option>Preferred Time</option>
                    <option>Morning</option>
                    <option>Afternoon</option>
                    <option>Evening</option>
                  </select>
                </div>
                <div className="col-12">
                  <button  onClick={handleSendEnquire}  type="button" className="btn btn-primary w-100 cta-btn">
                    Confirm Booking →
                  </button>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3 flex-wrap">
                <span className="pill">✅ Free Consult*</span>
                <span className="pill">🛡 Hygiene</span>
                <span className="pill">⚡ Fast Slots</span>
              </div>

              <div className="small text-muted mt-3">
                By booking, you agree to terms & privacy policy.
              </div>

            </div>
          </div>
        </div>

      </div>

      {/* Tabs */}
      <div className="mt-4">
        <ul className="nav nav-pills gap-2 navtabs flex-wrap">
          <li className="nav-item"><a className="nav-link active" href="#overview">Overview</a></li>
          <li className="nav-item"><a className="nav-link" href="#doctors">Doctors</a></li>
          <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
          {/* <li className="nav-item"><a className="nav-link" href="#reviews">Reviews</a></li> */}
          <li className="nav-item"><a className="nav-link" href="#faq">FAQ</a></li>
        </ul>
      </div>

    </div>
  </section>

  {/* OVERVIEW */}
  <section id="overview" className="py-5">
    <div className="container">
      <div className="row g-4">
        <div className="col-lg-8">
          <div className="glass p-4">
            <h5 className="fw-bold mb-2" style={{color:"var(--navy)"}}>About this Clinic</h5>
            <div className="text-muted mb-0">
             <div dangerouslySetInnerHTML={{ __html: Page.about }} />
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="glass p-4">
            <h6 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Highlights</h6>
            <div className="d-flex flex-column gap-2">
              
               {Page.certifications && Page.certifications.map((certification, index) => (
            <span className="pill">{certification.image} {certification.text}</span>
        ))}
               
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* DOCTORS (6 cards) */}
  <section id="doctors" className="py-5 bg-light">
    <div className="container">
      <div className="d-flex align-items-end justify-content-between flex-wrap gap-2 mb-3">
        <div>
          <h5 className="fw-bold mb-1" style={{color:"var(--navy)"}}>Doctor at this Clinic</h5>
          <div className="text-muted">Choose a specialist and book instantly</div>
        </div>

        <div className="bg-white rounded border ">
   <Select
            className="border-0 w-100 custom-none-border"
            id="department"
            name="department"
            options={data2.map(item => ({
              label: item,  // Option label (text)
              value: item,   // Option value (ID)
            }))}
            value={data2.find(item => item === filterInputs.department)  // Find the selected state
              ? {
                  label: data2.find(item => item === filterInputs.department),  // Display name of the state
                  value: data2.find(item => item === filterInputs.department),   // Use the state's ID as value
                }
              : null
            }
            onChange={(selectedOption) => handleInputChange({
              target: { name: "department", value: selectedOption?.value || "" }
            })}
            isClearable  // Optionally add a clear button
            placeholder={loading ? "Loading..." : "Select Department"}  // Change placeholder text to be more relevant
          />
        </div>
        
     

      </div>

      <div className="row g-4">
        {AllCategory && AllCategory.map((doctor,i)=>(
          <div className="col-lg-4 col-md-6" key={i}>
            <div className="doc-card p-4 h-100">
              <div className="d-flex gap-3">
                <img className="rounded-4"  style={{width:100}} src={
                                  doctor &&
                                  typeof doctor.profile === "string" &&
                                  doctor.profile !== ""
                                    ? weburl + doctor.profile.replace("public", "")
                                    : "/assets/img/placeholder.png"
                                }
                                onError={(e) =>
                                  (e.target.src = "/assets/img/placeholder.png")
                                } alt="doc" />
                <div className="flex-grow-1">
                  <div className="fw-bold"> {doctor.username} </div>
                  <div className="text-muted small">
                      {doctor.subDepartments && 
        <p className='m-0 text-primary fw-bold'>  {doctor.subDepartments.map((department, index) => (
          <span key={index} className='text-dark'>{department} ● </span>
        ))}
        </p>
        }
       </div>
                  <div className="d-flex gap-2 flex-wrap mt-2">
                    <span className="chip">{doctor.statename}</span>
                    <span className="chip">{doctor?.Experience || 1}+ yrs</span>
                    <span className="chip">Today Slots</span>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 mt-4">
                <Link  to={`/doctor/${doctor._id}`} className="btn btn-outline-primary w-50 rounded-pill">Profile</Link>
                <Link to={`/doctor/${doctor._id}`}  className="btn btn-primary w-50 rounded-pill">Book</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  {/* SERVICES */}
  
{Page.subDepartments && 
  <section id="services" className="py-5">
    <div className="container">
      <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Treatments & Services</h5>
      <div className="row g-4">

        
        { Page.subDepartments.map((s,idx)=>(
          <div className="col-lg-4 col-md-6" key={idx}>
            <div className="glass p-4 h-100">
              <div className="fw-bold mb-1">{s}</div>
              <div className="text-muted small mb-3">Safe, hygienic, specialist-led care.</div>
              {/* <button className="btn btn-outline-primary rounded-pill">Know More →</button> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>

}

  {/* REVIEWS */}
  <section id="reviews" className="py-5 bg-light d-none">
    <div className="container">
      <div className="glass p-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="fw-bold mb-1" style={{color:"var(--navy)"}}>Patient Reviews</h5>
            <div className="text-muted">Latest Google verified reviews</div>
          </div>
          <span className="pill">Google 4.9 ★★★★★ (250+)</span>
        </div>

        <div className="row g-3 mt-2">

                  {stories.map((story,index) => (

                         <div className="col-lg-4" key={index}>
              <div className="p-3 border rounded-4 bg-white h-100">
                <div className="fw-semibold">{story.doctor}, {story.hospital}</div>
                <div className="small text-muted mb-2">   {story.date} </div>
                <div className="small mb-2" style={{color:"#F4B400"}}>★★★★★</div>
                <div className="text-muted">
                 {story.title}
                </div>
              </div>
            </div>
 
            ))}

   
        </div>

      </div>
    </div>
  </section>

  {/* FAQ */}
  <section id="faq" className="py-5">
    <div className="container">
      <h5 className="fw-bold mb-3" style={{color:"var(--navy)"}}>Frequently Asked Questions</h5>

      <div className="accordion" id="faqAcc">
        {faqItems.map((faq, idx) => (
          <div className="accordion-item" key={idx}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${idx!==0 ? "collapsed":""}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq${idx}`}
                aria-expanded={idx === 0 ? "true" : "false"}
              >
                {faq.question}
              </button>
            </h2>
            <div id={`faq${idx}`} className={`accordion-collapse collapse ${idx===0 ? "show":""}`} data-bs-parent="#faqAcc">
              <div className="accordion-body text-muted">{faq.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
 


</>}
 

</main>



 

      <Footer />
    </>

  );
};

export default ViewHospital
